import {
  Hex,
  HexUtils,
  OffsetCoord,
  // Point,
  GridGenerator,
} from '../components/HexGrid';
// import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
// import { localizedImg } from '@tmsw/powerups.intl.hooks.use-localized-img';

function createPiecesFromConfig(config: any) {
  console.log('createPiecesFromConfig', config);

  let pieces = config.pieces.map((piece: Hex, i: string) => {
    let [col, row] = piece.id.split(',').map((v: string) => Number(v));
    const gridItem = new OffsetCoord(col, row);
    // zero-based coords to map to cube coords
    const axialCoords = new OffsetCoord(col - 1, row - 1);
    const hex = HexUtils.axialToOddq(axialCoords);

    console.log(`Mapping ${piece.id}`, hex.id);

    return {
      ...piece,
      ...hex,
      gridItem,
      text: hex.id,
      // text: `${gridItem.col},${gridItem.row}`,
    };
  });

  console.log(config, pieces);

  // @ts-ignore
  return GridGenerator.orientedRectangle(
    config.board.size.x,
    config.board.size.y
  )
    .map((hex) => {
      const piece = pieces.find((p: any) => p.id === hex.id);
      if (typeof piece !== 'undefined') {
        hex = { ...hex, ...piece };
      } else {
        console.log('Cannot find json data for piece ', hex.id);
        hex.missing = true;
      }
      return hex;
    })
    .filter((h) => !h.missing)
    .sort((h1, h2) => {
      if (!h1.gridItem) {
        return 1;
      }
      if (!h2.gridItem || h1.gridItem.row < h2.gridItem.row) {
        return -1;
      } else if (h1.gridItem.row === h2.gridItem.row) {
        return 0;
      } else {
        return 1;
      }
    });
}

/**
 * @return {levelConfig}
 */
// @ts-ignore
export function getLevelConfig({ gameLevel, inputBoard, inputPieces }) {
  // console.log('gameCharacter', gameCharacter);

  console.log('getLevelConfig :: board, pieces, rest', inputBoard, inputPieces);

  const gameBoard = {
    ...inputBoard,
    size: { x: Number(inputBoard.size.rows), y: Number(inputBoard.size.cols) },
    origin: { x: 0, y: 0 },
    flat: true,
    spacing: 1,
  };

  const pieces = createPiecesFromConfig({
    pieces: inputPieces,
    board: gameBoard,
  });

  const gameConfig = {
    board: gameBoard,
    pieces: pieces,
    gameLevel,
  };

  const levelConfig = {
    ...gameConfig,
  };

  console.log('levelConfig', levelConfig);
  return levelConfig;
}
